import React, {
  useState,
  useCallback,
  useEffect
} from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';

import useIsMountedRef from 'src/hooks/useIsMountedRef';
import IssueDetails from './IssueDetails';
import MperitoCard from 'src/components/MperitoCard';
import { fetchIssue, fetchONDCServerType } from 'src/actions/issuesActions';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));


function IssueDetailsView({ match, location }) {
  const {state} = useLocation();
  const dispatch = useDispatch();
  const data = state?.data;
  const [issueDetails, setIssueDetails ] = useState(null);
  const [serverTypes, setServerTypes ] = useState([]);

  const classes = useStyles();

    useEffect(() => {
      const fetchData = async (customerId, issueId) => {
        try {
          const details = await dispatch(fetchIssue(customerId, issueId));
          setIssueDetails(details); // fallback to [] to avoid undefined errors
          console.log("IssueDetailsView() : ", issueDetails);

          const data = await dispatch(fetchONDCServerType());
          setServerTypes(data || []);
        } catch (error) {
          console.error("Error fetching issues:", error);
          setIssueDetails(null);
          setServerTypes([]);
        }
      };
  
      if (data?.customerId && data?.issueId) {
        fetchData(data?.customerId, data?.issueId);
      }
    }, [data]);





  return (
    <Page
      className={classes.root}
      title="Issue Details"
    >
      <Container maxWidth="lg">
        <Header />
        <br/>
        <MperitoCard title={`Issue Details ( ${data?.customerId} - ${data?.issueId} )`}>
          <IssueDetails customerId={data?.customerId} issueId={data?.issueId} data={issueDetails?.issue} serverTypes={serverTypes} />
          {/* <IssueDetails customerId={data?.customerId} issueId={data?.issueId} data={issueData?.data?.issue} />         */}
        </MperitoCard>
        
      </Container>
    </Page>
  );
}

export default IssueDetailsView;


const issueData = {
    "error": false,
    "message": "Successfully fetched the issue",
    "data": {
        "issue": {
            "descriptor": {
                "additional_desc": {
                    "url": "https://ondc.org/assets/theme/images/ondc_registered_logo.svg?v=399788fda7",
                    "content_type": "image/png"
                },
                "images": [
                    {
                        "url": "https://ondc.org/assets/theme/images/ondc_registered_logo.svg?v=399788fda7",
                        "size_type": "xs"
                    }
                ],
                "code": "ITM002",
                "short_desc": "Some short description",
                "long_desc": "Some long description",
                "media": [
                    {
                        "_id": "68c3b2d505194edc4e9ed472",
                        "url": "https://ondc.org/assets/theme/images/ondc_registered_logo.svg?v=399788fda7"
                    }
                ]
            },
            "refs": [
                {
                    "ref_type": "ORDER",
                    "ref_id": "SS1757654097332"
                },
                {
                    "ref_type": "PROVIDER",
                    "ref_id": "109"
                },
                {
                    "ref_type": "FULFILLMENT",
                    "ref_id": "F_109_1"
                },
                {
                    "ref_type": "FULFILLMENT",
                    "ref_id": "C_109_3"
                },
                {
                    "ref_type": "ITEM",
                    "ref_id": "1614",
                    "tags": [
                        {
                            "descriptor": {
                                "code": "message.order.items"
                            },
                            "list": [
                                {
                                    "descriptor": {
                                        "code": "quantity.selected.count"
                                    },
                                    "value": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "ref_type": "ITEM",
                    "ref_id": "1614",
                    "tags": [
                        {
                            "descriptor": {
                                "code": "message.order.items"
                            },
                            "list": [
                                {
                                    "descriptor": {
                                        "code": "quantity.count"
                                    },
                                    "value": "2"
                                }
                            ]
                        }
                    ]
                }
            ],
            "actors": [
                {
                    "id": "id_1a79s_0",
                    "type": "CONSUMER",
                    "info": {
                        "person": {
                            "name": "Ayush Yadav"
                        },
                        "contact": {
                            "phone": "9990202525",
                            "email": "mail@ayushyadav.tech"
                        },
                        "org": {
                            "name": "pramaan.ondc.org/beta/preprod/mock/buyer::ONDC:RET10"
                        }
                    }
                },
                {
                    "id": "id_14w9dv_1",
                    "type": "INTERFACING_NP",
                    "info": {
                        "org": {
                            "name": "pramaan.ondc.org/beta/preprod/mock/buyer::ONDC:RET10"
                        },
                        "contact": {
                            "phone": "9033891671",
                            "email": "abc@ondc.in"
                        },
                        "person": {
                            "name": "Support Desk"
                        }
                    }
                },
                {
                    "id": "mperito.com",
                    "type": "COUNTERPARTY_NP",
                    "info": {
                        "org": {
                            "name": "mperito.com::ONDC:RET10"
                        },
                        "contact": {
                            "phone": "9450394140",
                            "email": "support@mindsclik.com"
                        },
                        "person": {
                            "name": "Mindsclik Helpdesk"
                        }
                    }
                }
            ],
            "respondent_ids": [
                "mperito.com"
            ],
            "resolver_ids": [],
            "actions": [
                {
                    "id": "id_17g6hr_0",
                    "descriptor": {
                        "code": "OPEN",
                        "short_desc": "Complaint created"
                    },
                    "updated_at": "2025-09-12T05:38:56.971Z",
                    "action_by": "id_14w9dv_1",
                    "actor_details": {
                        "name": "Support Desk"
                    }
                },
                {
                    "id": "mperito_540355_0",
                    "descriptor": {
                        "code": "PROCESSING",
                        "short_desc": "in-progress"
                    },
                    "updated_at": "2025-09-12T05:38:58.154Z",
                    "action_by": "mperito.com",
                    "actor_details": {
                        "name": "mindsclik"
                    }
                },
                {
                    "updated_at": "2025-09-12T05:42:25.081Z",
                    "action_by": "mperito.com",
                    "actor_details": {
                        "name": "mindsclik"
                    },
                    "descriptor": {
                        "code": "INFO_REQUESTED",
                        "short_desc": "image",
                        "name": "INFO001"
                    },
                    "id": "mperito_024933_0"
                },
                {
                    "id": "id_7y2hr_0",
                    "ref_id": "mperito_024933_0",
                    "descriptor": {
                        "code": "INFO_PROVIDED",
                        "short_desc": "Info provided from buyer app",
                        "images": [
                            {
                                "url": "https://ondc.org/assets/theme/images/ondc-network-vertical.png?v=01c8480ca3",
                                "size_type": "xs"
                            },
                            {
                                "url": "https://ondc.org/assets/theme/images/ondc-network-vertical.png?v=01c8480ca3",
                                "size_type": "xs"
                            }
                        ]
                    },
                    "updated_at": "2025-09-12T05:42:44.063Z",
                    "action_by": "id_14w9dv_1",
                    "actor_details": {
                        "name": "Support Desk"
                    }
                }
            ],
            "resolutions": [],
            "id": "SS1757654027427",
            "status": "PROCESSING",
            "level": "ISSUE",
            "expected_response_time": {
                "duration": "PT2H"
            },
            "expected_resolution_time": {
                "duration": "P1D"
            },
            "source_id": "id_1a79s_0",
            "complainant_id": "id_14w9dv_1",
            "last_action_id": "id_7y2hr_0",
            "created_at": "2025-09-12T05:38:56.971Z",
            "updated_at": "2025-09-12T05:42:44.063Z"
        },
        "update_target": [
            {
                "path": "issue.actions",
                "action": "APPENDED"
            }
        ],
        "_id": "68c3b1f205194e2bec9ed46e"
    }
}